import { useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { useContent } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import SectionHeader from '@/components/ui/SectionHeader';
import NavArrow from '@/components/ui/NavArrow';
import s from './Cases.module.scss';

// 설치 사례 — 융합 사이트(evstech 설치사례) 현장 사진 11장(정사각, 캡션 없음).
//   기존 News/Solutions 가로 카드 캐러셀 스타일 재현: 네이티브 scroll + ×3 복제 무한 loop + NavArrow + 풀블리드.
//   헤더는 News/Solutions 와 동일(제목 + 우측 화살표, tagline/divider 없음).
//   ※시험 도입(사용자 2026-07-31 "일단 한번 넣어볼까"). 사진 톤이 낡은 편 → 유지 시 교체/보정 고려.
//   TODO: News·Solutions·Cases 3곳이 같은 네이티브 scroll-loop 패턴 → 유지 확정되면 공통 CardCarousel 로 추출.
const STEP = 420; // 카드 400 + gap 20

const Cases = observer(() => {
  const { cases } = useContent();
  const reveal = useReveal<HTMLDivElement>();
  const trackRef = useRef<HTMLDivElement>(null);

  const loopItems = [...cases.items, ...cases.items, ...cases.items];
  const setWidth = cases.items.length * STEP;

  useEffect(() => {
    const el = trackRef.current;
    if (el) el.scrollLeft = setWidth; // 중간 세트에서 시작
  }, [setWidth]);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    let t: ReturnType<typeof setTimeout>;
    const onScroll = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const sl = el.scrollLeft;
        if (sl < setWidth) el.scrollLeft = sl + setWidth;
        else if (sl >= setWidth * 2) el.scrollLeft = sl - setWidth;
      }, 130);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => { el.removeEventListener('scroll', onScroll); clearTimeout(t); };
  }, [setWidth]);

  const scrollByCard = (dir: number) =>
    trackRef.current?.scrollBy({ left: dir * STEP, behavior: 'smooth' });

  return (
    <section className={s.section}>
      <div className={s.inner}>
        <SectionHeader
          title={cases.title}
          actions={<>
            <Link to="/cases" className={s.viewAll}>전체 보기 →</Link>
            <NavArrow dir="prev" onClick={() => scrollByCard(-1)} />
            <NavArrow dir="next" onClick={() => scrollByCard(1)} />
          </>}
        />
      </div>
      <div className={s.viewport} ref={reveal}>
        <div className={s.track} ref={trackRef}>
          {/* [2026-09-09 사용자] 홈 설치사례는 미리보기 → 클릭 시 /cases(신규 도입사례 페이지)로. */}
          {loopItems.map((c, i) => (
            <Link key={`${c.id}-${i}`} to="/cases" className={`${s.card} anim-scroll`} aria-label="설치 사례 전체 보기">
              <img src={c.src} alt="EVS 설치 사례" loading="lazy" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
});

export default Cases;
